module.exports = __webpack_public_path__ + "img/novelty-participation-transfer.1d75c02f.png";